export default `{
	memberRestriction {
    denouncesAvailable
    dueDate
    status
	}
}`;